<template>
    <task-list :columns="columns" :filterable="true">
    </task-list>
</template>

<script>
    import {compare} from "../utils/request";

    import TaskList from "../biomed-components/TaskList";
    export default {
        name: "BenchmarkList",
        components: {
            TaskList
        },
        data(){
            return {
                columns: [
                    {
                        title: 'Question',
                        dataIndex: 'Question',
                        width: 450,
                        sorter: {
                            compare: compare('Question'),
                        },
                        customFilterDropdown: true,
                        onFilter: (value, record) =>
                            record.Question.toString().toLowerCase().includes(value.toLowerCase()),
                    },
                    {
                        title: 'Task type',
                        dataIndex: 'Task subclass',
                        width: 190,
                        align: 'center',
                        sorter: {
                            compare: compare('Task subclass'),
                        },
                        customFilterDropdown: true,
                        onFilter: (value, record) =>
                            record['Task subclass'].toString().toLowerCase().includes(value.toLowerCase()),
                    },
                    {
                        title: 'Dataset',
                        dataIndex: 'Files',
                        width: 180,
                        // align: 'center'
                    },
                    {
                        title: 'Question type',
                        dataIndex: 'QuestionType',
                        align: 'center',
                        sorter: {
                            compare: compare('QuestionType'),
                        },
                    },
                    {
                        title: 'Reference steps',
                        dataIndex: '参考step数',
                        align: 'center',
                        sorter: {
                            compare: compare('参考step数'),
                        },
                    },
                    {
                        title: 'Milestones for evaluation',
                        dataIndex: '参考里程碑',
                        align: 'center'
                    },
                    {
                        title: 'Annotated results',
                        dataIndex: '里程碑参考文件',
                        width: 190,
                    },
                    {
                        dataIndex: 'test_info',
                        align: 'center',
                        slots: { title: 'customTitle', customRender: 'testInfo' },
                        width: 120,
                    },
                ]
            }
        },
        created(){
        },
        methods: {

        }
    }
</script>
<style>

</style>
